import styled from 'styled-components';

export const Figure = styled.figure`
    width: fit-content;
    height: fit-content;
`

export const Figcaption = styled.figcaption`
    text-align: center;
`